/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRoboticsAdapter = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 4C8.057 4 5.7 6.343 5.7 9.198c0 1.794.927 3.382 2.35 4.319l.45.296v2.583h-2c-.838 0-1.342.19-1.658.415-.314.224-.535.548-.687.983-.232.664-.264 1.431-.263 2.206H8v2H1.9v-1c0-.123-.002-.261-.005-.413-.014-.911-.036-2.284.372-3.452.252-.722.683-1.432 1.416-1.953.616-.439 1.378-.696 2.288-.766a7.15 7.15 0 0 1-2.201-4.218H2v-2h1.77C4.264 4.685 7.325 2 11 2c3.675 0 6.736 2.685 7.23 6.198H20v2h-1.7v.77h-2v-1.77C16.3 6.343 13.943 4 11 4zm-1.7 6.969h-2V7.427h2zm5.4 0h-2V7.427h2zM16.5 15a2.5 2.5 0 0 0 0 5H18v-5zm3.5 2v1h2v2h-2v2h-3.5a4.502 4.502 0 0 1-4.388-3.5H10v-2h2.111A4.502 4.502 0 0 1 16.5 13H20v2h2v2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRoboticsAdapter as RoboticsAdapter };
